const CONTACT_ITEMS = [
  { label: "Address", value: "Spodnji Plavz 27", icon: "ri-map-pin-line" },
  { label: "City", value: "Jesenice", icon: "ri-building-line" },
  { label: "ZIP Code", value: "4270", icon: "ri-mail-open-line" },
  { label: "Country", value: "Slovenia", icon: "ri-earth-line" },
  { label: "Email", value: "help@aldegodoo.com", icon: "ri-at-line" },
  { label: "Phone", value: "+1 8383681096", icon: "ri-phone-line" },
];

export default function ContactSection() {
  return (
    <section
      id="contact"
      className="w-full pt-24 pb-0"
      style={{ background: "#060606" }}
    >
      <div className="max-w-7xl mx-auto px-8 pb-16">
        {/* Label */}
        <div className="mb-4">
          <span className="text-[#00d4c8] text-xs font-bold tracking-[0.25em] uppercase">
            GET IN TOUCH
          </span>
        </div>

        {/* Title + description */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <h2 className="text-5xl md:text-6xl font-extrabold text-white leading-tight">
            Contact
            <br />
            <span className="text-[#00d4c8]">ALDEGO d.o.o.</span>
          </h2>
          <p className="text-[#7a7a7a] text-lg max-w-md leading-relaxed">
            Have a question or want to learn more about our iOS applications?
            Reach out to our team — we&apos;d love to hear from you.
          </p>
        </div>

        {/* Contact grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
          {CONTACT_ITEMS.map((item) => (
            <div
              key={item.label}
              className="bg-[#0f0f0f] border border-white/5 rounded-2xl px-8 py-6 flex items-start gap-4 hover:border-[#00d4c8]/20 transition-colors duration-300"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#00d4c8]/10 flex-shrink-0 mt-0.5">
                <i className={`${item.icon} text-[#00d4c8] text-lg`} />
              </div>
              <div>
                <p className="text-[#00d4c8] text-xs font-bold tracking-[0.18em] uppercase mb-1.5">
                  {item.label}
                </p>
                <p className="text-white text-base font-medium">{item.value}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer bar */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-8 py-7 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-7 h-7 flex items-center justify-center">
              <img
                src="https://public.readdy.ai/ai/img_res/c9c8380b-5887-4a3f-869a-ffb60b7eec79.png"
                alt="ALDEGO d.o.o."
                className="w-7 h-7 object-contain"
              />
            </div>
            <span className="text-[#4a4a4a] text-sm font-semibold">ALDEGO d.o.o.</span>
          </div>
          <p className="text-[#3a3a3a] text-sm">
            &copy; {new Date().getFullYear()} ALDEGO d.o.o. All rights reserved.
          </p>
          <p className="text-[#3a3a3a] text-sm">iOS Application Development</p>
        </div>
      </div>
    </section>
  );
}
